// Vendors
import $ from 'jquery';

// update mobile dropdown button text
function updateMobileFilter(changeText) {
  let dropdownButtonText = $('#filter-videos-mobile span.dropdown-selection');
  dropdownButtonText.html(changeText);
}

// video filtering function
function videoFilter(clickedCategory) {
  // get all filterable results
  let allArticles = $('.filterable-results article');

  // Make all articles fade
  allArticles.addClass('fade');

  // remove fade effect after second
  setTimeout(function () {
    allArticles.removeClass('fade');
    // hide all results using class "hidden", using string and .match(), remove "hidden" class from filtered results
    allArticles.addClass('hidden');
    for (var i = 0; i < allArticles.length; i++) {
      if (clickedCategory != '') {
        if (allArticles[i].matches(clickedCategory)) {
          allArticles[i].classList.remove('hidden');
        }
      }
    }
  }, 1000);
}

// video desktop filter
$('.video-filter button').on('click', (event) => {
  event.preventDefault();

  // remove class current from all buttons and add to clicked button
  $('.video-filter button').removeClass('current');
  $(event.currentTarget).addClass('current');

  // get category slug and text from element value
  let clickedText = $(event.currentTarget).text();
  let clickedVal = $(event.currentTarget).val();

  // update mobile filter
  updateMobileFilter(clickedText);

  // filter function
  videoFilter(clickedVal);
});

// video and anchor button dropdowns
$(document).on('click', '.video-dropdown', (event) => {
  event.stopPropagation();
  $('.video-filter-dropdown').toggleClass('dropdown-visible');
});

$(document).on('click', '.anchor-dropdown', (event) => {
  event.stopPropagation();
  $('.anchor-button-dropdown').toggleClass('dropdown-visible');
});

// anchor dropdown close on click
$('.anchor-button-dropdown .dropdown__item a').on('click', (event) => {
  $('.anchor-button-dropdown').removeClass('dropdown-visible');
});

// video mobile filter
$('.video-filter-dropdown .dropdown__item button').on('click', (event) => {
  event.preventDefault();

  // get selected value and text
  let clickedText = $(event.currentTarget).text();
  let clickedVal = $(event.currentTarget).val();

  // change text in dropdown button
  updateMobileFilter(clickedText);

  // close dropdown
  $('.video-filter-dropdown').removeClass('dropdown-visible');

  // update desktop filter category
  let desktopFilters = $('.video-filter button');
  desktopFilters.removeClass('current');
  for (var i = 0; i < desktopFilters.length; i++) {
    let desktopFilterVal = $(desktopFilters[i]).val();
    // console.log(desktopFilterVal);
    if (desktopFilterVal == clickedVal) {
      desktopFilters[i].classList.add('current');
    }
  }

  // filter function
  videoFilter(clickedVal);
});
